import React from 'react';
import {connect} from 'react-redux';
import Time from '../components/numbers/Time';
import ArrLeftButton from '../components/buttons/ArrLeftButton';
import ArrRightButton from '../components/buttons/ArrRightButton';
import {FormattedNumber} from 'react-intl';
import {countDiscountPrice, isNeedArrayPrint, preparePrintArray, print} from '../../common/lib/util';
import {setAllowSale} from '../../common/categories/actions';
import {closeMenu} from '../../common/menu/actions';
import {fetchBarReportReceipts, clearBarReportReceipts} from '../../common/report/receipt/actions';
import {selectReceiptToPrint, selectReceiptToShow, selectReceiptToStorno, selectReceiptToShowOnline,
    selectReceiptToPrintOnline, selectReceiptToStornoOnline} from '../../common/storno/actions';
import {showPopupInMenu} from '../../common/menu/actions';
import Popup from './popup/Popup'
import Print from '../print/Print';

class Storno extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        billPrintAllowed: React.PropTypes.bool,
        closeMenu: React.PropTypes.func,
        selectReceiptToStornoOnline: React.PropTypes.func,
        selectReceiptToPrintOnline: React.PropTypes.func,
        selectReceiptToShowOnline: React.PropTypes.func,
        selectReceiptToStorno: React.PropTypes.func,
        clearBarReportReceipts: React.PropTypes.func,
        fetchBarReportReceipts: React.PropTypes.func,
        selectReceiptToShow: React.PropTypes.func,
        selectReceiptToPrint: React.PropTypes.func,
        showPopupInMenu: React.PropTypes.func,
        sentBills: React.PropTypes.object,
        receipts: React.PropTypes.object,
        bar: React.PropTypes.object,
        organization: React.PropTypes.object,
        orderToPrint: React.PropTypes.object,
        branch: React.PropTypes.object,
        cashboxes: React.PropTypes.object,
        vats: React.PropTypes.object,
        deviceId: React.PropTypes.number,
        page: React.PropTypes.number,
        limit: React.PropTypes.number,
        max: React.PropTypes.number,
        barId: React.PropTypes.number,
        homepage: React.PropTypes.object.isRequired,
        printingInProgress: React.PropTypes.bool,
        setAllowSale: React.PropTypes.func,
        setForbidSale: React.PropTypes.func,
        silentPrint: React.PropTypes.bool,
        printType: React.PropTypes.string,
        printAddress: React.PropTypes.string,
        printLength: React.PropTypes.number
    };

    constructor(props) {
        super(props);

        this.doStorno = this.doStorno.bind(this);
        this.printBill = this.printBill.bind(this);
        this.print = this.print.bind(this);
        this.showBill = this.showBill.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.getCashboxName = this.getCashboxName.bind(this)
    }

    nextPage() {
        const {fetchBarReportReceipts, barId, limit, page, vats} = this.props;
        fetchBarReportReceipts(barId, limit, page + 1, vats);
    }

    prevPage() {
        const {fetchBarReportReceipts, barId, limit, page, vats} = this.props;
        fetchBarReportReceipts(barId, limit, page - 1, vats);
    }

    componentWillMount() {
        const {fetchBarReportReceipts, barId, limit, page, vats} = this.props;
        fetchBarReportReceipts(barId, limit, page, vats);
    }

    componentWillUnmount() {
        const {clearBarReportReceipts} = this.props;
        clearBarReportReceipts();
    }

    showBill(receipt, isOnlineReceipts) {
        const {showPopupInMenu, selectReceiptToShow, selectReceiptToShowOnline, printingInProgress} = this.props;
        if (!printingInProgress) {
            if (isOnlineReceipts) {
                selectReceiptToShowOnline(receipt);
            } else {
                selectReceiptToShow(receipt.get('number'));
            }
            showPopupInMenu(true);
        }
    }

    doStorno(receipt, isOnlineReceipts) {
        const {homepage, selectReceiptToStorno, selectReceiptToStornoOnline, printingInProgress, closeMenu} = this.props;
        if (!printingInProgress) {
            if (isOnlineReceipts) {
                selectReceiptToStornoOnline(receipt);
            } else {
                selectReceiptToStorno(receipt.get('number'));
            }
            window.setTimeout(function () {
                homepage.doOrder(true, false);
            }, 200);
            closeMenu();
        }
    }

    print() {
        const {
            setAllowSale, printType, bar, organization, orderToPrint, branch, cashboxes, deviceId, silentPrint,
            printAddress, printLength, billPrintAllowed, msg
        } = this.props;

        const printArray = !!isNeedArrayPrint(printType)
            ? preparePrintArray(bar, organization, orderToPrint, branch, cashboxes, null, null, null, deviceId, msg)
            : null;

        print(printType, printAddress, printArray, silentPrint, printLength, true, billPrintAllowed);
        setTimeout(function () {
            setAllowSale();
        }, 3500);
    }

    printBill(receipt, isOnlineReceipts) {
        const {
            printingInProgress,  selectReceiptToPrint, selectReceiptToPrintOnline
        } = this.props;
        if (!printingInProgress) {
            if (isOnlineReceipts) {
                selectReceiptToPrintOnline(receipt);
            } else {
                selectReceiptToPrint(receipt.get('number'));
            }
            const print = this.print;
            setTimeout(function () {
                print();
            }, 200);
        }
    }

    getCashboxName(id) {
        const {cashboxes} = this.props;
        if (!cashboxes) {
            return '';
        }
        for (const [index, cashbox] of cashboxes) {
            if (index == id) {
                return cashbox.get('name')
            }
        }
        return '';
    }

    render() {
        const {deviceId, sentBills, printingInProgress, receipts, max, page, limit, msg} = this.props;

        let bills;
        const isOnlineReceipts = max > 0;
        if (isOnlineReceipts) {
            bills = receipts;
        } else {
            bills = sentBills.sortBy(r => r.get('number')).reverse();
        }

        return (
            <div className="menuPage">
                <Popup body={<Print className="print-preview" />}/>
                <div className="menuPage-header">
                  <div className="menuPage-header-title" style={{width: '80%'}}>
                    <div className="menuPage-title">
                        {msg.issuedReceipts.title}
                    </div>
                  </div>
                  {isOnlineReceipts &&
                  <div className="menuPage-header-key">
                    <div className={`boxBtn color-white ${page < 1 ? 'disabled' : ''}`}
                         onClick={() => this.prevPage()}>
                      <ArrLeftButton/>
                    </div>
                  </div>
                  }
                  {isOnlineReceipts &&
                    <div className="menuPage-header-key">
                        <div className={`boxBtn color-white ${page === (Math.ceil(max / limit) - 1) ? 'disabled' : ''}`}
                             onClick={() => this.nextPage()}>
                            <ArrRightButton/>
                        </div>
                      </div>
                    }
                </div>

              <div className="menuPage-content">
                <div className="table">

                    <div className="table-head">
                        <div className="table-head-row">
                            <div className="table-head-cell" style={{width: '10%'}}>
                                <span>{msg.issuedReceipts.time}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '17%'}}>
                                <span>{msg.issuedReceipts.table}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '25%'}}>
                                <span>{msg.issuedReceipts.items}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '16%'}}>
                                <span>{msg.issuedReceipts.sum}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '12%'}}>
                                <span>{msg.issuedReceipts.cashbox}</span>
                            </div>
                        </div>
                    </div>
                    <div className="table-body">
                        {!!bills && bills.map((receipt, i) =>
                            <div className="table-row"
                                 key={`sentBills-${i}`}>

                                <div className="table-cell" style={{width: '10%'}}
                                     onClick={() => this.showBill(receipt, isOnlineReceipts)}>
                                    <div className="boxBtn text-black">
                                        <div className="boxBtn-inner">
                                            <Time value={receipt.get('time')}/>
                                        </div>
                                    </div>
                                </div>

                                <div className="table-cell" style={{width: '17%'}}
                                     onClick={() => this.showBill(receipt, isOnlineReceipts)}>
                                    <div className="boxBtn text-left text-black">
                                        <div className="boxBtn-inner">
                                            <span>{receipt.get('device') === null ? deviceId : receipt.get('device')}-{receipt.get('number')}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="table-cell" style={{width: '25%'}}
                                     onClick={() => this.showBill(receipt, isOnlineReceipts)}>
                                    <div className="boxBtn text-left text-black">
                                        <div className="boxBtn-inner">
                                            <span>
                                                {!!receipt.get('selectedProducts') && receipt.get('selectedProducts')
                                                    .map((item, i) =>
                                                    <span key={`item${receipt.get('number')}-${i}`}>
                                                        {item.get('name')}
                                                        {receipt.get('selectedProducts').last().get('id') !== item.get('id') && ', '}
                                                    </span>
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="table-cell" style={{width: '16%'}}
                                     onClick={() => this.showBill(receipt, isOnlineReceipts)}>
                                    <div className="boxBtn text-right text-black">
                                        <div className="boxBtn-inner">
                                            <span>
                                                {receipt.get('storno') && '-'}
                                                <FormattedNumber style="decimal"
                                                                 maximumFractionDigits={2}
                                                                 minimumFractionDigits={2}
                                                                 value={countDiscountPrice(receipt.get('totalPriceVat').toFixed(2), receipt.get('discount'))}/> Kč
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="table-cell" style={{width: '12%'}}
                                     onClick={() => this.showBill(receipt, isOnlineReceipts)}>
                                        <div className="boxBtn text-center text-black">
                                            <div className="boxBtn-inner">
                                                {this.getCashboxName(receipt.get('cashbox'))}
                                            </div>
                                        </div>
                                </div>

                                <div className="table-cell" style={{width: '10%'}}>
                                    <div className={`boxBtn color-greenLight ${!printingInProgress ? '' : 'disabled'}`}
                                         onClick={() => this.printBill(receipt, isOnlineReceipts)}>
                                        <div className="boxBtn-inner">
                                            <span>{msg.global.print}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-cell" style={{width: '10%'}}>
                                    {!receipt.get('storno') && !!receipt.get('canDelete') &&
                                        <div
                                            className={`boxBtn color-red ${!printingInProgress && !receipt.get('canceled') ? '' : 'disabled'}`}
                                            onClick={() => this.doStorno(receipt, isOnlineReceipts)}>
                                            <div className="boxBtn-inner">
                                                <span>{msg.issuedReceipts.storno}</span>
                                            </div>
                                        </div>
                                    }
                                </div>

                            </div>
                        )}
                    </div>
                </div>
              </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    organization: state.categories.get('organization'),
    orderToPrint: state.categories.get('orderToPrint'),
    bar: state.bars.get('bar'),
    branch: state.branches.get('branch'),
    cashboxes: state.cashboxes.get('cashboxes'),
    sentBills: state.categories.get('sentBills'),
    vats: state.categories.get('vats'),
    deviceId: state.device.get('id'),
    barId: state.bars.getIn(['bar', 'id']),
    printingInProgress: state.categories.get('printingInProgress'),
    receipts: state.barReportReceipt.get('receipts'),
    limit: state.barReportReceipt.get('limit'),
    silentPrint: state.device.get('silentPrint'),
    printType: state.device.get('printType'),
    billPrintAllowed: state.device.get('billPrint'),
    printAddress: state.device.get('printAddress'),
    page: state.barReportReceipt.get('page'),
    max: state.barReportReceipt.get('max'),
    printLength: state.device.get('printLength')
}), {selectReceiptToStorno, setAllowSale, selectReceiptToPrint, showPopupInMenu, selectReceiptToShow,
    fetchBarReportReceipts, clearBarReportReceipts, selectReceiptToShowOnline, selectReceiptToPrintOnline,
    selectReceiptToStornoOnline, closeMenu})(Storno);



// WEBPACK FOOTER //
// ./src/browser/menu/Storno.js